import { ActivatedRoute } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BsDatepickerConfig } from "ngx-bootstrap";
import { JoineeService } from "src/app/services/joinee.service";
import { MotorService } from "src/app/services/motor.service";
import { SpinnerService } from "src/app/services/spinner.service";
import { DatePipe } from "@angular/common";
import { Constants } from "src/app/shared/constants";
import { AlertService } from "src/app/services/alert.service";
import * as CryptoJS from "crypto-js";

@Component({
  selector: "app-new-joinee-application",
  templateUrl: "./selected-candidate-detail-form.component.html",
  styleUrls: ["./selected-candidate-detail-form.component.css"],
})
export class SelectedCandidateDetailFormComponent implements OnInit {
  selectedCandidateForm: FormGroup;
  errors: any = [];
  result: any = [];
  educationDetails: any = [];
  trainginDetials: any = [];
  workExperienceDetails: any = [];
  candidateDocuments: any = [];
  submitted = false;
  dataLength: any;
  keys: any;
  adultMinDOB: Date;
  adultMaxDOB: Date;
  pdfOnly: boolean = false;
  submitFlag: boolean = false;
  nextFlag: boolean = true;
  nextt: boolean = true;
  cvId: string;

  navPageNo = 1;

  showQuestion1: boolean = false;
  showQuestion2: boolean = false;
  showQuestion3: boolean = false;
  showQuestion4: boolean = false;
  showQuestion5: boolean = false;
  showQuestion6: boolean = false;
  showQuestion7: boolean = false;
  showQuestion8: boolean = false;

  showCandidateDetails: boolean = true;
  showCandidateAddressDetails: boolean = false;
  showCandidateEductionalDetails: boolean = false;
  showCandidateTrainingDetails: boolean = false;
  showCandidateFamilyDetails: boolean = false;
  showCandidateWorkExperienceDetails: boolean = false;
  showCandidateReferenceDetails: boolean = false;
  showCandidateQuestionsDetails: boolean = false;
  showCandidateDocumentsUpload: boolean = false;

  editEducationDetail: boolean = false;
  editEducationIndex: any;

  editTrainingDetails: boolean = false;
  editTrainingIndex: any;

  editWorkDetail: boolean = false;
  editWorkDetailIndex: any;

  disabledShowCandidateDetails: boolean = false;
  disabledShowCandidateAddressDetails: boolean = true;
  disabledShowCandidateEductionalDetails: boolean = true;
  disabledShowCandidateTrainingDetails: boolean = true;
  disabledShowCandidateFamilyDetails: boolean = true;
  disabledShowCandidateWorkExperienceDetails: boolean = true;
  disabledShowCandidateReferenceDetails: boolean = true;
  disabledShowCandidateQuestionsDetails: boolean = true;
  disabledShowCandidateDocumentsUpload: boolean = true;

  educationFromMinDate: Date;
  educationFromMaxDate: Date;
  educationToMinDate: Date;
  educationToMaxDate: Date;

  trainingFromMinDate: Date;
  trainingFromMaxDate: Date;
  trainingToMinDate: Date;
  trainingToMaxDate: Date;

  workExperienceFromMinDate: Date;
  workExperienceFromMaxDate: Date;
  workExperienceToMinDate: Date;
  workExperienceToMaxDate: Date;

  checkDetailsExists: Boolean = false;
  returned: Boolean = false;

  fetchCandidateDetails: any;

  candidateDocumentDataList: any;
  document1Flag: boolean = false;
  document2Flag: boolean = false;
  document3Flag: boolean = false;
  document4Flag: boolean = false;
  document5Flag: boolean = false;
  document6Flag: boolean = false;
  document7Flag: boolean = false;
  document8Flag: boolean = false;
  document9Flag: boolean = false;
  document10Flag: boolean = false;
  document11Flag: boolean = false;
  document12Flag: boolean = false;
  document13Flag: boolean = false;
  document14Flag: boolean = false;
  document15Flag: boolean = false;

  id1;
  id2;
  id3;
  id4;
  id5;
  id6;
  id7;
  id8;
  id9;
  id10;
  id11;
  id12;
  id13;
  id14;
  id15;

  photo: any;
  aadhar: any;
  PAN: any;
  updatedCV: any;
  highschool: any;
  inter: any;
  grad: any;
  postGrad: any;
  degree: any;
  insuranceCertificate: any;
  previousCompany: any;
  ctcStructure: any;
  last3Months: any;
  offerCurrent: any;
  others: any;

  bsDatepickerConfig: Partial<BsDatepickerConfig> = {};

  list: any = [
    "0 - 3 Lakh",
    "3 - 5 Lakh",
    "5 - 7 Lakh",
    "7 - 9 Lakh",
    "9 - 11 Lakh",
    "11 Lakh & Above",
  ];
  list1: any = ["Post-Graduation", "Graduation", "Diploma"];
  list2: any = ["NIL", "Fellowship", "Associate", "Licentiate"];
  list3: any = [
    " 0 - 1 Year",
    "1 - 4 Years",
    "4 - 9 Years",
    "9 - 12 Years",
    "12 Years & above",
  ];
  list4: any = [
    18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 38, 39, 40, 41, 42, 43, 44, 45,
  ];
  list5: any = [
    "Marketing",
    "Underwriting",
    "Claims",
    "Finance & Accounts",
    "IT",
    "Legal",
    "Actuary",
    "Other",
  ];
  list6: any = ["NIL", "15 Days", "1 Month", "2 Months", "3 Months"];
  list7: any = ["Yes", "No"];
  list8: any = [
    "ANDAMAN & NICOBAR",
    "ANDHRA PRADESH",
    "ARUNACHAL PRADESH",
    "ASSAM",
    "BIHAR",
    "CHANDIGARH",
    "DAMAN AND DIU",
    "DADRA AND NAGAR HAVELI",
    "GOA",
    "GUJARAT",
    "HARYANA",
    "HIMACHAL PRADESH",
    "JHARKHAND",
    "JAMMU AND KASHMIR",
    "KARNATAKA",
    "KERALA",
    "LAKSHDWEEP",
    "MAHARASHTRA",
    "MANIPUR",
    "MEGHALAYA",
    "MIZORAM",
    "MADHYA PRADESH",
    "NAGALAND",
    "NEW DELHI",
    "ORISSA",
    "PONDICHERRY",
    "PUNJAB",
    "RAJASTHAN",
    "SIKKIM",
    "TAMILNADU",
    "TRIPURA",
    "TELANGANA",
    "UTTAR PRADESH",
    "UTTRANCHAL",
    "CHHATTISGARH",
    "WEST BENGAL",
  ];

  salutationList: any = ["Mr.", "Ms.", "Mrs."];
  degreeList: any = [
    "10th",
    "12th",
    "Diploma",
    "Graduation",
    "PostGraduation",
    "Other",
  ];

  gapDisabled: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: SpinnerService,
    private joineeService: JoineeService,
    private motorService: MotorService,
    public datepipe: DatePipe,
    private alert: AlertService,
    private activatedRoute: ActivatedRoute
  ) {
    this.bsDatepickerConfig.dateInputFormat = "DD/MM/YYYY";
    this.bsDatepickerConfig.containerClass = "theme-green";
    this.bsDatepickerConfig.showWeekNumbers = false;
    const startDate = new Date(new Date().setHours(0, 0, 0, 0));

    this.adultMinDOB = new Date(startDate.getTime());
    this.adultMinDOB.setFullYear(startDate.getFullYear() - 18);
    this.adultMaxDOB = new Date(startDate.getTime());
    this.adultMaxDOB.setFullYear(startDate.getFullYear() - 150);

    this.educationFromMinDate = new Date(startDate.getTime());
    this.educationFromMinDate.setFullYear(startDate.getFullYear() - 0);
    this.educationFromMaxDate = new Date(startDate.getTime());
    this.educationFromMaxDate.setFullYear(startDate.getFullYear() - 150);

    this.educationToMinDate = new Date(startDate.getTime());
    this.educationToMinDate.setFullYear(startDate.getFullYear() - 0);
    this.educationToMaxDate = new Date(startDate.getTime());
    this.educationToMaxDate.setFullYear(startDate.getFullYear() - 150);

    this.trainingFromMinDate = new Date(startDate.getTime());
    this.trainingFromMinDate.setFullYear(startDate.getFullYear() - 0);
    this.trainingFromMaxDate = new Date(startDate.getTime());
    this.trainingFromMaxDate.setFullYear(startDate.getFullYear() - 150);

    this.trainingToMinDate = new Date(startDate.getTime());
    this.trainingToMinDate.setFullYear(startDate.getFullYear() - 0);
    this.trainingToMaxDate = new Date(startDate.getTime());
    this.trainingToMaxDate.setFullYear(startDate.getFullYear() - 150);

    this.workExperienceFromMinDate = new Date(startDate.getTime());
    this.workExperienceFromMinDate.setFullYear(startDate.getFullYear() - 0);
    this.workExperienceFromMaxDate = new Date(startDate.getTime());
    this.workExperienceFromMaxDate.setFullYear(startDate.getFullYear() - 150);

    this.workExperienceToMinDate = new Date(startDate.getTime());
    this.workExperienceToMinDate.setFullYear(startDate.getFullYear() - 0);
    this.workExperienceToMaxDate = new Date(startDate.getTime());
    this.workExperienceToMaxDate.setFullYear(startDate.getFullYear() - 150);

    // this.activatedRoute.queryParams.subscribe(data=>{
    //   // console.log(data);
    //   this.cvId = data.cvId;
    //   console.log(this.cvId);
    // })
  }

  get f() {
    return this.selectedCandidateForm.controls;
  }

  ngOnInit(): void {
    
    this.activatedRoute.queryParams.subscribe((data) => {
      this.cvId = data.cvId;
      // console.log(this.cvId);
    });

    this.cvId = CryptoJS.AES.decrypt(
      this.cvId,
      CryptoJS.enc.Utf8.parse("hey@123451234545"),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);

    // console.log(this.cvId);

    this.selectedCandidateForm = this.formBuilder.group({
      salutation: ["", [Validators.required]],
      name: ["", [Validators.required]],
      dateOfBirth: ["", [Validators.required]],
      panNumber: ["", [Validators.required]],
      aadharNumber: ["", [Validators.required]],
      nationality: ["", [Validators.required]],
      positionAppliedFor: ["", [Validators.required]],
      fatherName: ["", [Validators.required]],
      fatherAadhar: ["", []],
      motherName: ["", [Validators.required]],
      motherAadhar: ["", []],
      emergencyContactName: ["", [Validators.required]],
      emergencyContactNumber: ["", [Validators.required]],
      emergencyContactRelation: ["", [Validators.required]],
      permanentHouseNo: ["", [Validators.required]],
      permanentStreet: ["", [Validators.required]],
      permanentState: ["", [Validators.required]],
      permanentPinCode: ["", [Validators.required]],
      permanentEmailId: [
        "",
        [Validators.required, Validators.pattern(Constants.EMAIL_REGEX)],
      ],
      permanentMobileNo: ["", [Validators.required]],
      permanentFaxNo: ["", []],
      mailingHouseNo: ["", []],
      mailingStreet: ["", []],
      mailingState: ["", []],
      mailingPinCode: ["", []],
      mailingMobileNo: ["", []],
      mailingFaxNo: ["", []],
      familyBackground: ["", [Validators.required]],
      eduationResult: ["", [Validators.required]],
      institute: ["", [Validators.required]],
      degree: ["", [Validators.required]],
      educationFromDate: ["", [Validators.required]],
      educationFromTo: ["", [Validators.required]],
      coreSubject: ["", [Validators.required]],
      trainingCurriculum: ["", [Validators.required]],
      trainingFromDate: ["", [Validators.required]],
      trainingFromTo: ["", [Validators.required]],

      read: ["", [Validators.required]],
      write: ["", [Validators.required]],
      speak: ["", [Validators.required]],

      lastCompanyName: ["", [Validators.required]],
      lastCompanyLocation: ["", [Validators.required]],
      lastCompanyFromDate: ["", [Validators.required]],
      lastCompanyFromTo: ["", [Validators.required]],
      lastCompanyDesigantion: ["", [Validators.required]],
      lastCompanyCTC: ["", [Validators.required]],
      lastCompanyReasontoChange: ["", [Validators.required]],
      lastCompanyManager: ["", [Validators.required]],
      lastCompanyManagerNumber: ["", [Validators.required]],

      reference1Name: ["", [Validators.required]],
      reference1Address: ["", [Validators.required]],
      reference1ContactNo: ["", [Validators.required]],
      reference2Name: ["", [Validators.required]],
      reference2Address: ["", [Validators.required]],
      reference2ContactNo: ["", [Validators.required]],
      referenceQuestion: ["", [Validators.required]],

      question1: ["", [Validators.required]],
      question2: ["", [Validators.required]],
      question3: ["", [Validators.required]],
      question4: ["", [Validators.required]],
      question5: ["", [Validators.required]],
      question6: ["", [Validators.required]],
      question7: ["", [Validators.required]],
      question8: ["", [Validators.required]],

      question1Answer: ["", []],
      question2Answer: ["", []],
      question3Answer: ["", []],
      question4Answer: ["", []],
      question5Answer: ["", []],
      question6Answer: ["", []],
      question7Answer: ["", []],
      question8Answer: ["", []],
      sameMailingAddress: ["", [Validators.required]],

      passportSizePhoto: ["", [Validators.required]],
      aadhar: ["", [Validators.required]],
      panCard: ["", [Validators.required]],
      uploadCV: ["", [Validators.required]],
      // gapDeclaration: ['', []],
      marksheet10th: ["", [Validators.required]],
      marksheet12th: ["", [Validators.required]],
      graduationMarksheet: ["", [Validators.required]],
      postGraduationMarksheet: ["", []],
      provisionalCertificate: ["", [Validators.required]],
      insuranceCertificate: ["", []],
      experienceLetterPreviousComapny: ["", []],
      ctcStructure: ["", []],
      salarySlip3Months: ["", []],
      offerLetterOfCurrentCompany: ["", []],
      achievementCertificate: ["", []],
    });

    this.f.educationFromDate.valueChanges.subscribe((value) => {
      this.selectedCandidateForm.controls.educationFromTo.reset();
      this.setEducationMaxDate();
    });

    this.f.trainingFromDate.valueChanges.subscribe((value) => {
      this.selectedCandidateForm.controls.trainingFromTo.reset();
      this.setTrainingMaxDate();
    });

    this.f.lastCompanyFromDate.valueChanges.subscribe((value) => {
      this.selectedCandidateForm.controls.lastCompanyFromTo.reset();
      this.setWorkExperienceMaxDate();
    });

    this.f.aadhar.valueChanges.subscribe((value) => {
      if (this.f.aadhar.value[0].type != "application/pdf") {
        this.alert.info("Please upload only pdf files");
        this.selectedCandidateForm.controls.aadhar.reset();
      }
    });

    // this.f.question1.setValue(false);
    // this.f.question1Answer.disable();
    // this.f.question2Answer.disable();
    // this.f.question3Answer.disable();
    // this.f.question4Answer.disable();
    // this.f.question5Answer.disable();
    // this.f.question6Answer.disable();
    // this.f.question7Answer.disable();
    // this.f.question8Answer.disable();

    this.checkAlreadyExist(this.cvId);
  }

  // workExperienceBFSI(){
  //   if(this.selectedCandidateForm.controls.workExperienceInBFSI.value){
  //     this.f.experienceInInsuranceIndustry.disable();
  //     this.selectedCandidateForm.controls.experienceInInsuranceIndustry.setValue('');
  //   }
  //   else{
  //     this.f.experienceInInsuranceIndustry.enable();
  //   }

  // }

  setEducationMaxDate() {
    this.educationToMaxDate = new Date(
      this.selectedCandidateForm.controls.educationFromDate.value
    );
  }

  setTrainingMaxDate() {
    this.trainingToMaxDate = new Date(
      this.selectedCandidateForm.controls.trainingFromDate.value
    );
  }

  setWorkExperienceMaxDate() {
    this.workExperienceToMaxDate = new Date(
      this.selectedCandidateForm.controls.lastCompanyFromDate.value
    );
  }

  async toBase64(file: File) {
    const arrayBuffer = (await readFileAsync(file)) as ArrayBuffer;
    let binary = "";
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
    function readFileAsync(file: File) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    }
  }

  addEducaitonDetail() {
    
    if (
      !this.selectedCandidateForm.controls.degree.valid ||
      !this.selectedCandidateForm.controls.institute.valid ||
      !this.selectedCandidateForm.controls.educationFromDate.valid ||
      !this.selectedCandidateForm.controls.educationFromTo.valid ||
      !this.selectedCandidateForm.controls.coreSubject.valid ||
      !this.selectedCandidateForm.controls.eduationResult.valid
    ) {
      return;
    }
    if(this.editEducationDetail){
      const data = this.selectedCandidateForm.getRawValue();
      this.educationDetails[this.editEducationIndex].degree = data.degree;
      this.educationDetails[this.editEducationIndex].institute = data.institute;
      this.educationDetails[this.editEducationIndex].durationFrom = data.educationFromDate;
      this.educationDetails[this.editEducationIndex].durationTo = data.educationFromTo;
      this.educationDetails[this.editEducationIndex].specialization = data.coreSubject;
      this.educationDetails[this.editEducationIndex].result = data.eduationResult;
      this.editEducationDetail = false;
      this.editEducationIndex = null;
    }else{
      const data = this.selectedCandidateForm.getRawValue();
      const payload = {
        degree: data.degree,
        institute: data.institute,
        durationFrom: data.educationFromDate,
        durationTo: data.educationFromTo,
        specialization: data.coreSubject,
        result: data.eduationResult,
      };

      this.educationDetails.push(payload);
    }
    
    this.selectedCandidateForm.controls.degree.reset();
    this.selectedCandidateForm.controls.institute.reset();
    this.selectedCandidateForm.controls.educationFromDate.reset();
    this.selectedCandidateForm.controls.educationFromTo.reset();
    this.selectedCandidateForm.controls.coreSubject.reset();
    this.selectedCandidateForm.controls.eduationResult.reset();
  }

  addTrainingDetails() {
    
    if (
      !this.selectedCandidateForm.controls.trainingCurriculum.valid ||
      !this.selectedCandidateForm.controls.trainingFromDate.valid ||
      !this.selectedCandidateForm.controls.trainingFromTo.valid
    ) {
      return;
    }

    if(this.editTrainingDetails){
      const data = this.selectedCandidateForm.getRawValue();
      this.trainginDetials[this.editTrainingIndex].trainingCurriculum = data.trainingCurriculum;
      this.trainginDetials[this.editTrainingIndex].durationFrom = data.trainingFromDate;
      this.trainginDetials[this.editTrainingIndex].durationTo = data.trainingFromTo;
      this.editTrainingDetails = false;
      this.editTrainingIndex = null;
    }else{
      const data = this.selectedCandidateForm.getRawValue();
      const payload = {
        trainingCurriculum: data.trainingCurriculum,
        durationFrom: data.trainingFromDate,
        durationTo: data.trainingFromTo,
      };

      this.trainginDetials.push(payload);
    }
    
    this.selectedCandidateForm.controls.trainingCurriculum.reset();
    this.selectedCandidateForm.controls.trainingFromDate.reset();
    this.selectedCandidateForm.controls.trainingFromTo.reset();
  }

  addWorkExperience() {
    
    if (
      !this.selectedCandidateForm.controls.lastCompanyName.valid ||
      !this.selectedCandidateForm.controls.lastCompanyLocation.valid ||
      !this.selectedCandidateForm.controls.lastCompanyFromDate.valid ||
      !this.selectedCandidateForm.controls.lastCompanyFromTo.valid ||
      !this.selectedCandidateForm.controls.lastCompanyDesigantion.valid ||
      !this.selectedCandidateForm.controls.lastCompanyCTC.valid ||
      !this.selectedCandidateForm.controls.lastCompanyReasontoChange.valid ||
      !this.selectedCandidateForm.controls.lastCompanyManager.valid ||
      !this.selectedCandidateForm.controls.lastCompanyManagerNumber.valid
    ) {
      return;
    }

    if(this.editWorkDetail){
      const data = this.selectedCandidateForm.getRawValue();
      this.workExperienceDetails[this.editWorkDetailIndex].nameOfCompany = data.lastCompanyName;
      this.workExperienceDetails[this.editWorkDetailIndex].location = data.lastCompanyLocation;
      this.workExperienceDetails[this.editWorkDetailIndex].durationFrom = data.lastCompanyFromDate;
      this.workExperienceDetails[this.editWorkDetailIndex].durationTo = data.lastCompanyFromTo;
      this.workExperienceDetails[this.editWorkDetailIndex].designation = data.lastCompanyDesigantion;
      this.workExperienceDetails[this.editWorkDetailIndex].costToComapany = data.lastCompanyCTC;
      this.workExperienceDetails[this.editWorkDetailIndex].reasonForChange = data.lastCompanyReasontoChange;
      this.workExperienceDetails[this.editWorkDetailIndex].lastReportingManger = data.lastCompanyManager;
      this.workExperienceDetails[this.editWorkDetailIndex].lastReportingManagerContactNo = data.lastCompanyManagerNumber;
      this.editWorkDetail = false;
      this.editWorkDetailIndex = null;
    }
    else{
      const data = this.selectedCandidateForm.getRawValue();
      const payload = {
        nameOfCompany: data.lastCompanyName,
        location: data.lastCompanyLocation,
        durationFrom: data.lastCompanyFromDate,
        durationTo: data.lastCompanyFromTo,
        designation: data.lastCompanyDesigantion,
        costToComapany: data.lastCompanyCTC,
        reasonForChange: data.lastCompanyReasontoChange,
        lastReportingManger: data.lastCompanyManager,
        lastReportingManagerContactNo: data.lastCompanyManagerNumber,
      };

      this.workExperienceDetails.push(payload);
    }

    
    this.selectedCandidateForm.controls.lastCompanyName.reset();
    this.selectedCandidateForm.controls.lastCompanyLocation.reset();
    this.selectedCandidateForm.controls.lastCompanyFromDate.reset();
    this.selectedCandidateForm.controls.lastCompanyFromTo.reset();
    this.selectedCandidateForm.controls.lastCompanyDesigantion.reset();
    this.selectedCandidateForm.controls.lastCompanyCTC.reset();
    this.selectedCandidateForm.controls.lastCompanyReasontoChange.reset();
    this.selectedCandidateForm.controls.lastCompanyManager.reset();
    this.selectedCandidateForm.controls.lastCompanyManagerNumber.reset();
  }

  question1() {
    
    if (this.selectedCandidateForm.controls.question1.value) {
      // this.f.question1Answer.disable();
      this.f.question1Answer.setValidators([]);
      this.selectedCandidateForm.controls.question1Answer.reset();
      this.showQuestion1 = false;
    } else {
      // this.f.question1Answer.enable();
      this.f.question1Answer.setValidators([Validators.required]);

      this.showQuestion1 = true;
    }
    this.f.question1Answer.updateValueAndValidity();
  }

  question2() {
    
    if (this.selectedCandidateForm.controls.question2.value) {
      this.f.question2Answer.setValidators([]);
      this.selectedCandidateForm.controls.question2Answer.reset();
      this.showQuestion2 = false;
    } else {
      this.f.question2Answer.setValidators([Validators.required]);
      this.showQuestion2 = true;
    }
  }
  question3() {
    
    if (this.selectedCandidateForm.controls.question3.value) {
      this.f.question3Answer.setValidators([]);
      this.selectedCandidateForm.controls.question3Answer.reset();
      this.showQuestion3 = false;
    } else {
      this.f.question3Answer.setValidators([Validators.required]);
      this.showQuestion3 = true;
    }
  }

  question4() {
    
    if (this.selectedCandidateForm.controls.question4.value) {
      this.f.question4Answer.setValidators([]);
      this.selectedCandidateForm.controls.question4Answer.reset();
      this.showQuestion4 = false;
    } else {
      this.f.question4Answer.setValidators([Validators.required]);
      this.showQuestion4 = true;
    }
  }

  question5() {
    
    if (this.selectedCandidateForm.controls.question5.value) {
      this.f.question5Answer.setValidators([]);
      this.selectedCandidateForm.controls.question5Answer.reset();
      this.showQuestion5 = false;
    } else {
      this.f.question5Answer.setValidators([Validators.required]);
      this.showQuestion5 = true;
    }
  }

  question6() {
    
    if (this.selectedCandidateForm.controls.question6.value) {
      this.f.question6Answer.setValidators([]);
      this.selectedCandidateForm.controls.question6Answer.reset();
      this.showQuestion6 = false;
    } else {
      this.f.question6Answer.setValidators([Validators.required]);
      this.showQuestion6 = true;
    }
  }

  question7() {
    
    if (this.selectedCandidateForm.controls.question7.value) {
      this.f.question7Answer.setValidators([]);
      this.selectedCandidateForm.controls.question7Answer.reset();
      this.showQuestion7 = false;
    } else {
      this.f.question7nswer.setValidators([Validators.required]);
      this.showQuestion7 = true;
    }
  }

  question8() {
    
    if (this.selectedCandidateForm.controls.question8.value) {
      this.f.question8Answer.setValidators([]);
      this.selectedCandidateForm.controls.question8Answer.reset();
      this.showQuestion8 = false;
    } else {
      this.f.question8Answer.setValidators([Validators.required]);
      this.showQuestion8 = true;
    }
  }

  onNextClick() {
    
    if (this.navPageNo == 9) {
      return;
    }

    if (this.navPageNo == 1) {
      if (
        !this.selectedCandidateForm.controls.salutation.valid ||
        !this.selectedCandidateForm.controls.name.valid ||
        !this.selectedCandidateForm.controls.dateOfBirth.valid ||
        !this.selectedCandidateForm.controls.panNumber.valid ||
        !this.selectedCandidateForm.controls.aadharNumber.valid ||
        !this.selectedCandidateForm.controls.fatherName.valid ||
        !this.selectedCandidateForm.controls.fatherAadhar.valid ||
        !this.selectedCandidateForm.controls.motherName.valid ||
        !this.selectedCandidateForm.controls.motherAadhar.valid ||
        !this.selectedCandidateForm.controls.emergencyContactName.valid ||
        !this.selectedCandidateForm.controls.emergencyContactNumber.valid ||
        !this.selectedCandidateForm.controls.emergencyContactRelation.valid ||
        !this.selectedCandidateForm.controls.positionAppliedFor.valid ||
        !this.selectedCandidateForm.controls.nationality.valid
      ) {
        this.alert.info(
          "Please fill all mandatory Details to Go to the next Page"
        );
        return;
      } else {
        this.showCandidateDetails = false;
        this.showCandidateAddressDetails = true;
        this.disabledShowCandidateAddressDetails = false;
        this.navPageNo = 2;
      }
    } else if (this.navPageNo == 2) {
      if (
        !this.selectedCandidateForm.controls.permanentHouseNo.valid ||
        !this.selectedCandidateForm.controls.permanentStreet.valid ||
        !this.selectedCandidateForm.controls.permanentState.valid ||
        !this.selectedCandidateForm.controls.permanentPinCode.valid ||
        !this.selectedCandidateForm.controls.permanentEmailId.valid ||
        !this.selectedCandidateForm.controls.permanentMobileNo.valid ||
        !this.selectedCandidateForm.controls.permanentFaxNo.valid ||
        !this.selectedCandidateForm.controls.mailingHouseNo.valid ||
        !this.selectedCandidateForm.controls.mailingStreet.valid ||
        !this.selectedCandidateForm.controls.mailingState.valid ||
        !this.selectedCandidateForm.controls.mailingPinCode.valid ||
        !this.selectedCandidateForm.controls.mailingMobileNo.valid ||
        !this.selectedCandidateForm.controls.mailingFaxNo.valid
      ) {
        this.alert.info(
          "Please fill all mandatory Details to Go to the next Page"
        );
        return;
      } else {
        this.showCandidateAddressDetails = false;
        this.showCandidateEductionalDetails = true;
        this.disabledShowCandidateEductionalDetails = false;
        this.navPageNo = 3;
      }
    } else if (this.navPageNo == 3) {
      
      let tenth = false;
      let twelth = false;
      this.educationDetails.forEach((education, index) => {
        if (education.degree == "10th") {
          tenth = true;
        } else if (education.degree == "12th") {
          twelth = true;
        } else if (education.degree == "Diploma") {
          twelth = true;
        }
      });
      if (!tenth || !twelth) {
        this.alert.info(
          "Please Add 10th, 12th Education Details(Mandatory) and any other revelant Education Details if Applicable"
        );
        return;
      } else {
        this.showCandidateEductionalDetails = false;
        this.showCandidateTrainingDetails = true;
        this.disabledShowCandidateTrainingDetails = false;
        this.navPageNo = 4;
      }
    } else if (this.navPageNo == 4) {
      // if (this.trainginDetials.length == 0) {
      //   return;
      // }
      // else {
      //   this.showCandidateTrainingDetails = false;
      //   this.showCandidateWorkExperienceDetails = true;

      //   this.navPageNo = 5;
      // }
      this.showCandidateTrainingDetails = false;
      this.showCandidateWorkExperienceDetails = true;
      this.disabledShowCandidateWorkExperienceDetails = false;

      this.navPageNo = 5;
    } else if (this.navPageNo == 5) {
      if (this.workExperienceDetails.length != 0) {
        this.selectedCandidateForm.controls.experienceLetterPreviousComapny.setValidators(
          [Validators.required]
        );
        this.selectedCandidateForm.controls.ctcStructure.setValidators([
          Validators.required,
        ]);
        this.selectedCandidateForm.controls.salarySlip3Months.setValidators([
          Validators.required,
        ]);
        this.selectedCandidateForm.controls.offerLetterOfCurrentCompany.setValidators(
          [Validators.required]
        );
      } else {
        this.selectedCandidateForm.controls.experienceLetterPreviousComapny.setValidators(
          []
        );
        this.selectedCandidateForm.controls.ctcStructure.setValidators([]);
        this.selectedCandidateForm.controls.salarySlip3Months.setValidators([]);
        this.selectedCandidateForm.controls.offerLetterOfCurrentCompany.setValidators(
          []
        );
      }
      this.showCandidateWorkExperienceDetails = false;
      this.showCandidateFamilyDetails = true;
      this.disabledShowCandidateFamilyDetails = false;

      // this.showCandidateWorkExperienceDetails = true;
      this.navPageNo = 6;
    } else if (this.navPageNo == 6) {
      if (
        !this.selectedCandidateForm.controls.familyBackground.valid ||
        !this.selectedCandidateForm.controls.speak.valid ||
        !this.selectedCandidateForm.controls.read.valid ||
        !this.selectedCandidateForm.controls.write.valid
      ) {
        this.alert.info(
          "Please fill all mandatory Details to Go to the next Page"
        );
        return;
      } else {
        this.showCandidateFamilyDetails = false;
        this.showCandidateReferenceDetails = true;
        this.disabledShowCandidateReferenceDetails = false;
        // this.showCandidateWorkExperienceDetails = true;
        this.navPageNo = 7;
      }
    } else if (this.navPageNo == 7) {
      if (
        !this.selectedCandidateForm.controls.reference1Name.valid ||
        !this.selectedCandidateForm.controls.reference1Address.valid ||
        !this.selectedCandidateForm.controls.reference1ContactNo.valid ||
        !this.selectedCandidateForm.controls.reference2Name.valid ||
        !this.selectedCandidateForm.controls.reference2Address.valid ||
        !this.selectedCandidateForm.controls.reference2ContactNo.valid ||
        !this.selectedCandidateForm.controls.referenceQuestion.valid
      ) {
        this.alert.info(
          "Please fill all mandatory Details to Go to the next Page"
        );
        return;
      } else {
        const today = new Date();
        let hasMoreThan30DaysDifference = true;
        this.workExperienceDetails.forEach((experience, index) => {
          if (experience.durationTo) {
            const endDate = new Date(experience.durationTo);
            const diffInMs = today.getTime() - endDate.getTime();

            // Convert to days
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            if (diffInDays < 30) {
              hasMoreThan30DaysDifference = false;
            }
          }
        });

        if (hasMoreThan30DaysDifference == true) {
          this.f.question8.setValue(true);
          this.f.question8Answer.setValidators([Validators.required]);
          this.showQuestion8 = true;
          this.gapDisabled = true;
        } else {
          this.f.question8.setValue(false);
          this.f.question8Answer.setValidators([]);
          this.showQuestion8 = false;
          this.gapDisabled = false;
        }

        this.showCandidateReferenceDetails = false;
        this.showCandidateQuestionsDetails = true;
        this.disabledShowCandidateQuestionsDetails = false;

        this.navPageNo = 8;
      }
    } else if (this.navPageNo == 8) {
      if (
        !this.selectedCandidateForm.controls.question1Answer.valid ||
        !this.selectedCandidateForm.controls.question2Answer.valid ||
        !this.selectedCandidateForm.controls.question3Answer.valid ||
        !this.selectedCandidateForm.controls.question4Answer.valid ||
        !this.selectedCandidateForm.controls.question5Answer.valid ||
        !this.selectedCandidateForm.controls.question6Answer.valid ||
        !this.selectedCandidateForm.controls.question7Answer.valid ||
        !this.selectedCandidateForm.controls.question8Answer.valid
      ) {
        this.alert.info(
          "Please fill all mandatory Details to Go to the next Page"
        );
        return;
      } else {
        this.showCandidateQuestionsDetails = false;
        this.showCandidateDocumentsUpload = true;
        this.disabledShowCandidateDocumentsUpload = false;
        this.navPageNo = 9;
        this.nextFlag = false;
        this.submitFlag = true;
      }
    }
  }

  onPrevClick() {
    if (this.navPageNo == 1) {
      return;
    }

    if (this.navPageNo == 2) {
      this.showCandidateDetails = true;
      this.showCandidateAddressDetails = false;
      this.navPageNo = 1;
    } else if (this.navPageNo == 3) {
      this.showCandidateAddressDetails = true;
      this.showCandidateEductionalDetails = false;
      this.navPageNo = 2;
    } else if (this.navPageNo == 4) {
      this.showCandidateEductionalDetails = true;
      this.showCandidateTrainingDetails = false;
      this.navPageNo = 3;
    } else if (this.navPageNo == 5) {
      this.showCandidateTrainingDetails = true;
      this.showCandidateFamilyDetails = false;
      this.navPageNo = 4;
    } else if (this.navPageNo == 6) {
      this.showCandidateFamilyDetails = true;
      this.showCandidateWorkExperienceDetails = false;
      this.navPageNo = 5;
    } else if (this.navPageNo == 7) {
      this.showCandidateWorkExperienceDetails = true;
      this.showCandidateReferenceDetails = false;
      this.navPageNo = 6;
    } else if (this.navPageNo == 8) {
      this.showCandidateReferenceDetails = true;
      this.showCandidateQuestionsDetails = false;
      this.navPageNo = 7;
    } else if (this.navPageNo == 9) {
      this.showCandidateDocumentsUpload = false;
      this.showCandidateQuestionsDetails = true;
      this.navPageNo = 8;
      this.submitFlag = false;
      this.nextFlag = true;
    }
  }

  mailingAddress() {
    
    if (this.selectedCandidateForm.controls.sameMailingAddress.value) {
      this.selectedCandidateForm.controls.mailingHouseNo.reset();
      this.selectedCandidateForm.controls.mailingStreet.reset();
      this.selectedCandidateForm.controls.mailingState.reset();
      this.selectedCandidateForm.controls.mailingPinCode.reset();
      this.selectedCandidateForm.controls.mailingMobileNo.reset();
      this.selectedCandidateForm.controls.mailingFaxNo.reset();
    } else {
      this.selectedCandidateForm.controls.mailingHouseNo.setValue(
        this.selectedCandidateForm.controls.permanentHouseNo.value
      );
      this.selectedCandidateForm.controls.mailingStreet.setValue(
        this.selectedCandidateForm.controls.permanentStreet.value
      );
      this.selectedCandidateForm.controls.mailingState.setValue(
        this.selectedCandidateForm.controls.permanentState.value
      );
      this.selectedCandidateForm.controls.mailingPinCode.setValue(
        this.selectedCandidateForm.controls.permanentPinCode.value
      );
      this.selectedCandidateForm.controls.mailingMobileNo.setValue(
        this.selectedCandidateForm.controls.permanentMobileNo.value
      );
      this.selectedCandidateForm.controls.mailingFaxNo.setValue(
        this.selectedCandidateForm.controls.permanentFaxNo.value
      );
    }
  }

  removeEducationalDetail(data: any) {
    
    this.educationDetails.splice(data, 1);
  }
  removeTrainingDetails(data: any) {
    
    this.trainginDetials.splice(data, 1);
  }
  removeWorkExperience(data: any) {
    
    this.workExperienceDetails.splice(data, 1);
  }

  async onSubmit() {
    
    if (
      !this.selectedCandidateForm.controls.salutation.valid ||
      !this.selectedCandidateForm.controls.name.valid ||
      !this.selectedCandidateForm.controls.dateOfBirth.valid ||
      !this.selectedCandidateForm.controls.panNumber.valid ||
      !this.selectedCandidateForm.controls.aadharNumber.valid ||
      !this.selectedCandidateForm.controls.fatherName.valid ||
      !this.selectedCandidateForm.controls.fatherAadhar.valid ||
      !this.selectedCandidateForm.controls.motherName.valid ||
      !this.selectedCandidateForm.controls.motherAadhar.valid ||
      !this.selectedCandidateForm.controls.emergencyContactName.valid ||
      !this.selectedCandidateForm.controls.emergencyContactNumber.valid ||
      !this.selectedCandidateForm.controls.emergencyContactRelation.valid ||
      !this.selectedCandidateForm.controls.permanentHouseNo.valid ||
      !this.selectedCandidateForm.controls.permanentStreet.valid ||
      !this.selectedCandidateForm.controls.permanentState.valid ||
      !this.selectedCandidateForm.controls.permanentPinCode.valid ||
      !this.selectedCandidateForm.controls.permanentEmailId.valid ||
      !this.selectedCandidateForm.controls.permanentMobileNo.valid ||
      !this.selectedCandidateForm.controls.permanentFaxNo.valid ||
      !this.selectedCandidateForm.controls.mailingHouseNo.valid ||
      !this.selectedCandidateForm.controls.mailingStreet.valid ||
      !this.selectedCandidateForm.controls.mailingState.valid ||
      !this.selectedCandidateForm.controls.mailingPinCode.valid ||
      !this.selectedCandidateForm.controls.mailingMobileNo.valid ||
      !this.selectedCandidateForm.controls.mailingFaxNo.valid ||
      !this.selectedCandidateForm.controls.familyBackground.valid ||
      !this.selectedCandidateForm.controls.speak.valid ||
      !this.selectedCandidateForm.controls.read.valid ||
      !this.selectedCandidateForm.controls.write.valid ||
      !this.selectedCandidateForm.controls.reference1Name.valid ||
      !this.selectedCandidateForm.controls.reference1Address.valid ||
      !this.selectedCandidateForm.controls.reference1ContactNo.valid ||
      !this.selectedCandidateForm.controls.reference2Name.valid ||
      !this.selectedCandidateForm.controls.reference2Address.valid ||
      !this.selectedCandidateForm.controls.reference2ContactNo.valid ||
      !this.selectedCandidateForm.controls.referenceQuestion.valid ||
      !this.selectedCandidateForm.controls.question1Answer.valid ||
      !this.selectedCandidateForm.controls.question2Answer.valid ||
      !this.selectedCandidateForm.controls.question3Answer.valid ||
      !this.selectedCandidateForm.controls.question4Answer.valid ||
      !this.selectedCandidateForm.controls.question5Answer.valid ||
      !this.selectedCandidateForm.controls.question6Answer.valid ||
      !this.selectedCandidateForm.controls.question7Answer.valid ||
      !this.selectedCandidateForm.controls.question8Answer.valid ||
      this.educationDetails.length == 0
    ) {
      this.alert.info(
        "Please fill all mandatory Details before submitting your Request"
      );
      return;
    }

    if (
      !this.selectedCandidateForm.controls.passportSizePhoto.valid ||
      !this.selectedCandidateForm.controls.aadhar.valid ||
      !this.selectedCandidateForm.controls.panCard.valid ||
      !this.selectedCandidateForm.controls.uploadCV.valid ||
      // !this.selectedCandidateForm.controls.gapDeclaration.valid ||
      !this.selectedCandidateForm.controls.marksheet10th.valid ||
      !this.selectedCandidateForm.controls.marksheet12th.valid ||
      !this.selectedCandidateForm.controls.graduationMarksheet.valid ||
      !this.selectedCandidateForm.controls.postGraduationMarksheet.valid ||
      !this.selectedCandidateForm.controls.provisionalCertificate.valid ||
      !this.selectedCandidateForm.controls.insuranceCertificate.valid
    ) {
      if(!this.returned){
        this.alert.info("Please Upload all mandatory Documents");
        return;
      }
    }

    if (
      !this.selectedCandidateForm.controls.experienceLetterPreviousComapny
        .valid ||
      !this.selectedCandidateForm.controls.ctcStructure.valid ||
      !this.selectedCandidateForm.controls.salarySlip3Months.valid ||
      !this.selectedCandidateForm.controls.offerLetterOfCurrentCompany.valid ||
      !this.selectedCandidateForm.controls.achievementCertificate.valid
    ) {
      this.alert.info(
        "Please Upload all mandatory Documents in Employemnt Documents"
      );
      return;
    }

    const data = this.selectedCandidateForm.getRawValue();

    if (this.selectedCandidateForm.controls.passportSizePhoto.value) {
      if (this.selectedCandidateForm.controls.passportSizePhoto.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.passportSizePhoto.value[0].name,
          docType: "1",
          cvId: this.cvId,
          docTypeName: "Passport Size Photo",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.passportSizePhoto.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }
    if (this.selectedCandidateForm.controls.aadhar.value) {
      if (this.selectedCandidateForm.controls.aadhar.value[0]) {
        const data = {
          docName: this.selectedCandidateForm.controls.aadhar.value[0].name,
          docType: "2",
          cvId: this.cvId,
          docTypeName: "Aadhar Card",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.aadhar.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.panCard.value[0]) {
      if (this.selectedCandidateForm.controls.panCard.value[0]) {
        const data = {
          docName: this.selectedCandidateForm.controls.panCard.value[0].name,
          docType: "3",
          cvId: this.cvId,
          docTypeName: "Pan Card",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.panCard.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }
    if (this.selectedCandidateForm.controls.uploadCV.value) {
      if (this.selectedCandidateForm.controls.uploadCV.value[0]) {
        const data = {
          docName: this.selectedCandidateForm.controls.uploadCV.value[0].name,
          docType: "4",
          cvId: this.cvId,
          docTypeName: "Updated CV",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.uploadCV.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.marksheet10th.value) {
      if (this.selectedCandidateForm.controls.marksheet10th.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.marksheet10th.value[0].name,
          docType: "5",
          cvId: this.cvId,
          docTypeName: "10th Marksheet",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.marksheet10th.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.marksheet12th.value) {
      if (this.selectedCandidateForm.controls.marksheet12th.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.marksheet12th.value[0].name,
          docType: "6",
          cvId: this.cvId,
          docTypeName: "12th Marksheet",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.marksheet12th.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.graduationMarksheet.value) {
      if (this.selectedCandidateForm.controls.graduationMarksheet.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.graduationMarksheet.value[0]
              .name,
          docType: "7",
          cvId: this.cvId,
          docTypeName: "Graduation Marksheet",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.graduationMarksheet.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.postGraduationMarksheet.value) {
      if (
        this.selectedCandidateForm.controls.postGraduationMarksheet.value[0]
      ) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.postGraduationMarksheet.value[0]
              .name,
          docType: "8",
          cvId: this.cvId,
          docTypeName: "Post Graduation Marksheet",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.postGraduationMarksheet.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.provisionalCertificate.value) {
      if (this.selectedCandidateForm.controls.provisionalCertificate.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.provisionalCertificate.value[0]
              .name,
          docType: "9",
          cvId: this.cvId,
          docTypeName: "Degree/Provisional Certificate",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.provisionalCertificate.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.insuranceCertificate.value) {
      if (this.selectedCandidateForm.controls.insuranceCertificate.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.insuranceCertificate.value[0]
              .name,
          docType: "10",
          cvId: this.cvId,
          docTypeName: "Insurance Certification",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.insuranceCertificate.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (
      this.selectedCandidateForm.controls.experienceLetterPreviousComapny.value
    ) {
      if (
        this.selectedCandidateForm.controls.experienceLetterPreviousComapny
          .value[0]
      ) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.experienceLetterPreviousComapny
              .value[0].name,
          docType: "11",
          cvId: this.cvId,
          docTypeName: "Experience Letter Previous Comapany",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.experienceLetterPreviousComapny
              .value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.ctcStructure.value) {
      if (this.selectedCandidateForm.controls.ctcStructure.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.ctcStructure.value[0].name,
          docType: "12",
          cvId: this.cvId,
          docTypeName: "CTC structure previous Company",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.ctcStructure.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.salarySlip3Months.value) {
      if (this.selectedCandidateForm.controls.salarySlip3Months.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.salarySlip3Months.value[0].name,
          docType: "13",
          cvId: this.cvId,
          docTypeName: "Last 3 months Salary slip",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.salarySlip3Months.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.offerLetterOfCurrentCompany.value) {
      if (
        this.selectedCandidateForm.controls.offerLetterOfCurrentCompany.value[0]
      ) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.offerLetterOfCurrentCompany
              .value[0].name,
          docType: "14",
          cvId: this.cvId,
          docTypeName: "Offer Letter Current Company",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.offerLetterOfCurrentCompany
              .value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }

    if (this.selectedCandidateForm.controls.achievementCertificate.value) {
      if (this.selectedCandidateForm.controls.achievementCertificate.value[0]) {
        const data = {
          docName:
            this.selectedCandidateForm.controls.achievementCertificate.value[0]
              .name,
          docType: "15",
          cvId: this.cvId,
          docTypeName: "Achievement Certificates",
          document: await this.toBase64(
            this.selectedCandidateForm.controls.achievementCertificate.value[0]
          ),
          isActive: "1",
        };
        this.candidateDocuments.push(data);
      }
    }
    let tempid = null;

    if(this.fetchCandidateDetails){
      if(this.fetchCandidateDetails.id){
        tempid = this.fetchCandidateDetails.id;
      }
      else{
        tempid = null;
      }
    }

    const payload = {
      id: tempid,
      cvId: this.cvId,
      salutation: data.salutation,
      name: data.name,
      positionAppliedFor:data.positionAppliedFor,
      dateOfBirth: data.dateOfBirth,
      panNo: data.panNumber,
      aadharNo: data.aadharNumber,
      fatherName: data.fatherName,
      fatherAadhar: data.fatherAadhar,
      motherName: data.motherName,
      motherAadhar: data.motherAadhar,
      emergencyContactName: data.emergencyContactName,
      emergencyContactNumber: data.emergencyContactNumber,
      emergencyContactRelation: data.emergencyContactRelation,
      nationality: data.nationality,
      permanentHouseNo: data.permanentHouseNo,
      permanentStreet: data.permanentStreet,
      permanentState: data.permanentState,
      permanentPincode: data.permanentPinCode,
      permanentEmail: data.permanentEmailId,
      permanentMobile: data.permanentMobileNo,
      permanentFaxno: data.permanentFaxNo,
      mailingHouseNo: data.mailingHouseNo,
      mailingStreet: data.mailingStreet,
      mailingState: data.mailingState,
      mailingPincode: data.mailingPinCode,
      mailingMobile: data.mailingMobileNo,
      mailingFaxno: data.mailingFaxNo,
      familyBackground: data.familyBackground,
      languageSpeak: data.speak,
      languageRead: data.read,
      languageWrite: data.write,
      reference1Name: data.reference1Name,
      reference1Contact: data.reference1ContactNo,
      reference1Address: data.reference1Address,
      reference2Name: data.reference2Name,
      reference2Address: data.reference2Address,
      reference2Contact: data.reference2ContactNo,
      knowAboutVacancy: data.referenceQuestion,
      candidateEducationDetailList: this.educationDetails,
      candidateTrainingDetailList: this.trainginDetials,
      candidateWorkExperienceList: this.workExperienceDetails,
      question1: data.question1,
      question1Answer: data.question1Answer,
      question2: data.question2,
      question2Answer: data.question2Answer,
      question3: data.question3,
      question3Answer: data.question3Answer,
      question4: data.question4,
      question4Answer: data.question4Answer,
      question5: data.question5,
      question5Answer: data.question5Answer,
      question6: data.question6,
      question6Answer: data.question6Answer,
      question7: data.question7,
      question7Answer: data.question7Answer,
      question8: data.question8,
      question8Answer: data.question8Answer,
      candidateDocuments: this.candidateDocuments,
      returned:'0'
    };

    let enc = this.bfr(JSON.stringify(payload));

    const body = {
      zQ: enc,
    };
    // console.log(body);

    let res = await this.joineeService.saveCandidateDocuments(body);
    // const responses = await this.joineeService.saveCandidateDetails(payload);
    // let response = await this.joineeService.saveCandidateDocuments(body);
    // let response = await this.joineeService.saveCandidateDocuments(payload);
    const decrypt = this.decryptResponse(res.body);
    let response = JSON.parse(decrypt)
    // let res = await this.joineeService.saveCandidateDocuments(payload);
    if (response.message == "Success") {
      this.alert.info("Details saved Successfully");
      this.ngOnInit();
    } else {
      this.alert.info(
        "Error occur while submitting details, please try again after some time"
      );
    }
  }

  async checkAlreadyExist(cvId: string) {
    
    const payload = {
      cvId: this.cvId,
    };
    let enc = this.bfr(JSON.stringify(payload));

    const body = {
      zQ: enc,
    };

    let response = await this.joineeService.checkAlreadyExist(body);
    // let response = await this.joineeService.checkAlreadyExist(payload);
  //   let response = {
  //     "status": 200,
  //     "object": {
  //         "id": 77,
  //         "positionAppliedFor": "Tester",
  //         "cvId": "8114",
  //         "salutation": "Mr.",
  //         "name": "Hello",
  //         "dateOfBirth": "2007-08-01T00:00:00.000+05:30",
  //         "panNo": "qwert1234y",
  //         "aadharNo": "345678909876",
  //         "fatherName": "how",
  //         "fatherAadhar": "how",
  //         "motherName": "You",
  //         "motherAadhar": null,
  //         "emergencyContactName": "qwertyui",
  //         "emergencyContactNumber": "8765432345",
  //         "emergencyContactRelation": "wertyuio",
  //         "nationality": "Indian",
  //         "permanentHouseNo": "wertyuio",
  //         "permanentStreet": "wertyuio",
  //         "permanentState": "ANDAMAN & NICOBAR",
  //         "permanentPincode": "320826",
  //         "permanentEmail": "teee@gmail.com",
  //         "permanentMobile": "3456789876",
  //         "permanentFaxno": null,
  //         "mailingHouseNo": "wertyuio",
  //         "mailingStreet": "wertyuio",
  //         "mailingState": "ANDAMAN & NICOBAR",
  //         "mailingPincode": "320826",
  //         "mailingMobile": "3456789876",
  //         "mailingFaxno": null,
  //         "familyBackground": "wertyuio",
  //         "languageSpeak": "wertyui",
  //         "languageRead": "wertyui",
  //         "languageWrite": "wertyuio",
  //         "reference1Name": "wertyui",
  //         "reference1Address": "wertyuio",
  //         "reference1Contact": "234567890",
  //         "reference2Name": "wertyuio",
  //         "reference2Address": "wertyuio",
  //         "reference2Contact": "34567890",
  //         "referenceQuestion": "how",
  //         "question1": "false",
  //         "question1Answer": null,
  //         "question2": null,
  //         "question2Answer": null,
  //         "question3": null,
  //         "question3Answer": null,
  //         "question4": null,
  //         "question4Answer": null,
  //         "question5": null,
  //         "question5Answer": null,
  //         "question6": null,
  //         "question6Answer": null,
  //         "question7": null,
  //         "question7Answer": null,
  //         "question8": "true",
  //         "question8Answer": "wertyui sdfghjk sdfghjk",
  //         "itgiEmployee": null,
  //         "knowAboutVacancy": null,
  //         "returned": "1",
  //         "remarks": "Name does not match as per aadhar",
  //         "zQ": null,
  //         "candidateEducationDetailList": [
  //             {
  //                 "id": 52,
  //                 "candidateId": 77,
  //                 "degree": "10th",
  //                 "institute": "qwertyu",
  //                 "durationFrom": "2025-07-01T00:00:00.000+05:30",
  //                 "durationTo": "2025-08-01T11:42:31.000+05:30",
  //                 "specialization": "qwertyu",
  //                 "result": "69"
  //             },
  //             {
  //                 "id": 53,
  //                 "candidateId": 77,
  //                 "degree": "12th",
  //                 "institute": "qwertyui",
  //                 "durationFrom": "2025-08-01T11:42:31.000+05:30",
  //                 "durationTo": "2025-08-01T11:42:31.000+05:30",
  //                 "specialization": "wertyuio",
  //                 "result": "69"
  //             }
  //         ],
  //         "candidateTrainingDetailList": [
  //             {
  //                 "id": 1,
  //                 "candidateId": 77,
  //                 "trainingCurriculum": "qwertyui",
  //                 "durationFrom": "2025-08-01T11:42:31.000+05:30",
  //                 "durationTo": "2025-08-01T11:42:31.000+05:30"
  //             }
  //         ],
  //         "candidateWorkExperienceList": [
  //             {
  //                 "id": 7,
  //                 "candidateId": 77,
  //                 "nameOfCompany": "qwertyu",
  //                 "location": "wertyuio",
  //                 "durationFrom": "2025-06-01T00:00:00.000+05:30",
  //                 "durationTo": "2025-06-11T00:00:00.000+05:30",
  //                 "designation": "qwertyuio",
  //                 "costToComapany": "12",
  //                 "reasonForChange": "qwertyuio",
  //                 "lastReportingManger": "qwertyui",
  //                 "lastReportingManagerContactNo": "23456789"
  //             }
  //         ],
  //         "candidateDocuments": [
  //             {
  //                 "id": 84,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "HRMS test data.pdf",
  //                 "documentumId": "0901869f8009029f",
  //                 "docType": "16",
  //                 "docTypeName": "Approval Note",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-07-21T12:21:55.786+05:30"
  //             },
  //             {
  //                 "id": 85,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "bill123.jpg",
  //                 "documentumId": "0901869f800902a0",
  //                 "docType": "17",
  //                 "docTypeName": "Final Assessment",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-07-21T12:21:56.312+05:30"
  //             },
  //             {
  //                 "id": 193,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "test data image.pdf",
  //                 "documentumId": "0901869f800910e0",
  //                 "docType": "3",
  //                 "docTypeName": "test data image",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T10:18:57.383+05:30"
  //             },
  //             {
  //                 "id": 194,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "IOB ERROR.jpg",
  //                 "documentumId": "0901869f80091133",
  //                 "docType": "1",
  //                 "docTypeName": "Passport Size Photo",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T11:47:16.574+05:30"
  //             },
  //             {
  //                 "id": 195,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "ExitForm Remarks - 14258 (1).pdf",
  //                 "documentumId": "0901869f80091134",
  //                 "docType": "2",
  //                 "docTypeName": "Aadhar Card",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T11:47:16.798+05:30"
  //             },
  //             {
  //                 "id": 196,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "ExitForm Remarks - 14258 (1).pdf",
  //                 "documentumId": "0901869f80091135",
  //                 "docType": "3",
  //                 "docTypeName": "Pan Card",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T11:47:16.868+05:30"
  //             },
  //             {
  //                 "id": 197,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "ExitForm Remarks - 14258 (1).pdf",
  //                 "documentumId": "0901869f80091136",
  //                 "docType": "4",
  //                 "docTypeName": "Updated CV",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T11:47:16.943+05:30"
  //             },
  //             {
  //                 "id": 198,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "ExitForm Remarks - 14258 (1).pdf",
  //                 "documentumId": "0901869f80091137",
  //                 "docType": "5",
  //                 "docTypeName": "10th Marksheet",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T11:47:17.012+05:30"
  //             },
  //             {
  //                 "id": 199,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "ExitForm Remarks - 14258 (1).pdf",
  //                 "documentumId": "0901869f80091138",
  //                 "docType": "6",
  //                 "docTypeName": "12th Marksheet",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T11:47:17.075+05:30"
  //             },
  //             {
  //                 "id": 200,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "ExitForm Remarks - 14258.pdf",
  //                 "documentumId": "0901869f80091139",
  //                 "docType": "7",
  //                 "docTypeName": "Graduation Marksheet",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T11:47:17.130+05:30"
  //             },
  //             {
  //                 "id": 201,
  //                 "cvId": "8114",
  //                 "isActive": "1",
  //                 "docName": "ExitForm Remarks - 14258 (1).pdf",
  //                 "documentumId": "0901869f8009113a",
  //                 "docType": "9",
  //                 "docTypeName": "Degree/Provisional Certificate",
  //                 "ccEmail": null,
  //                 "toEmail": null,
  //                 "document": null,
  //                 "createdOn": "2025-08-04T11:47:17.192+05:30"
  //             }
  //         ]
  //     },
  //     "message": "Exists"
  // };
    // this.fetchCandidateDetails = response.object;

    // response = {"body": "LwZguzR1zxRcArFFZ+dTbVfmRYJyHqY45/kzQ5Kerh3JpnTLTMmxTN/9xDAhTuoY"};
    const decrypt = this.decryptResponse(response.body);
    // console.log(decrypt);
    let res = JSON.parse(decrypt)
    this.fetchCandidateDetails = res.object;
    // let res = JSON.parse(response)
    if (res.message == "Exists") {
      if (res.object.returned =='1') {
        this.setcandidateDetailForm(res.object);
        this.checkDetailsExists = false;
        this.returned = true;
        this.f.passportSizePhoto.setValidators([]);
        this.f.aadhar.setValidators([]);
        this.f.panCard.setValidators([]);
        this.f.uploadCV.setValidators([]);
        this.f.marksheet10th.setValidators([]);
        this.f.marksheet12th.setValidators([]);
        this.f.graduationMarksheet.setValidators([]);
        this.f.postGraduationMarksheet.setValidators([]);
        this.f.provisionalCertificate.setValidators([]);
        this.f.insuranceCertificate.setValidators([]);
        this.f.experienceLetterPreviousComapny.setValidators([]);
        this.f.ctcStructure.setValidators([]);
        this.f.salarySlip3Months.setValidators([]);
        this.f.offerLetterOfCurrentCompany.setValidators([]);
        this.f.achievementCertificate.setValidators([]);
      }
      else {
        this.checkDetailsExists = true;
        this.returned = false;
        // this.alert.info("Details already submitted");
      }
      
      return;
    } else {
      this.checkDetailsExists = false;
      this.returned = false;
    }
  }

  bfr(objectToEncode: string) {
    const key = CryptoJS.enc.Utf8.parse("nlFi2Xg2t4S2gk6i");
    const iv = CryptoJS.enc.Utf8.parse("nlFi2Xg2t4S2gk6i");
    const encrypted = CryptoJS.AES.encrypt(objectToEncode, key, {
      keySize: 16,
      iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  private decryptResponse(responseBody) {
    let decryptedResponse = CryptoJS.AES.decrypt(
      responseBody,
      CryptoJS.enc.Utf8.parse(Constants.ENCRYPTION_SECRET_KEY),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    let res = decryptedResponse.toString(CryptoJS.enc.Utf8);
    return res;
  }

  basicDetail() {
    this.navPageNo = 1;
    this.showCandidateDetails = true;
    this.showCandidateAddressDetails = false;
    this.showCandidateEductionalDetails = false;
    this.showCandidateTrainingDetails = false;
    this.showCandidateFamilyDetails = false;
    this.showCandidateWorkExperienceDetails = false;
    this.showCandidateReferenceDetails = false;
    this.showCandidateQuestionsDetails = false;
    this.showCandidateDocumentsUpload = false;

    this.nextFlag = true;
    this.submitFlag = false;
  }

  addessClick() {
    this.navPageNo = 2;
    this.showCandidateDetails = false;
    this.showCandidateAddressDetails = true;
    this.showCandidateEductionalDetails = false;
    this.showCandidateTrainingDetails = false;
    this.showCandidateFamilyDetails = false;
    this.showCandidateWorkExperienceDetails = false;
    this.showCandidateReferenceDetails = false;
    this.showCandidateQuestionsDetails = false;
    this.showCandidateDocumentsUpload = false;

    this.nextFlag = true;
    this.submitFlag = false;
  }
  educationalBackground() {
    this.navPageNo = 3;
    this.showCandidateDetails = false;
    this.showCandidateAddressDetails = false;
    this.showCandidateEductionalDetails = true;
    this.showCandidateTrainingDetails = false;
    this.showCandidateFamilyDetails = false;
    this.showCandidateWorkExperienceDetails = false;
    this.showCandidateReferenceDetails = false;
    this.showCandidateQuestionsDetails = false;
    this.showCandidateDocumentsUpload = false;

    this.nextFlag = true;
    this.submitFlag = false;
  }
  trainingAttended() {
    this.navPageNo = 4;
    this.showCandidateDetails = false;
    this.showCandidateAddressDetails = false;
    this.showCandidateEductionalDetails = false;
    this.showCandidateTrainingDetails = true;
    this.showCandidateFamilyDetails = false;
    this.showCandidateWorkExperienceDetails = false;
    this.showCandidateReferenceDetails = false;
    this.showCandidateQuestionsDetails = false;
    this.showCandidateDocumentsUpload = false;

    this.nextFlag = true;
    this.submitFlag = false;
  }
  workExperience() {
    this.navPageNo = 5;
    this.showCandidateDetails = false;
    this.showCandidateAddressDetails = false;
    this.showCandidateEductionalDetails = false;
    this.showCandidateTrainingDetails = false;
    this.showCandidateFamilyDetails = false;
    this.showCandidateWorkExperienceDetails = true;
    this.showCandidateReferenceDetails = false;
    this.showCandidateQuestionsDetails = false;
    this.showCandidateDocumentsUpload = false;

    this.nextFlag = true;
    this.submitFlag = false;
  }
  familyBackground() {
    this.navPageNo = 6;
    this.showCandidateDetails = false;
    this.showCandidateAddressDetails = false;
    this.showCandidateEductionalDetails = false;
    this.showCandidateTrainingDetails = false;
    this.showCandidateFamilyDetails = true;
    this.showCandidateWorkExperienceDetails = false;
    this.showCandidateReferenceDetails = false;
    this.showCandidateQuestionsDetails = false;
    this.showCandidateDocumentsUpload = false;

    this.nextFlag = true;
    this.submitFlag = false;
  }
  reference() {
    this.navPageNo = 7;
    this.showCandidateDetails = false;
    this.showCandidateAddressDetails = false;
    this.showCandidateEductionalDetails = false;
    this.showCandidateTrainingDetails = false;
    this.showCandidateFamilyDetails = false;
    this.showCandidateWorkExperienceDetails = false;
    this.showCandidateReferenceDetails = true;
    this.showCandidateQuestionsDetails = false;
    this.showCandidateDocumentsUpload = false;

    this.nextFlag = true;
    this.submitFlag = false;
  }
  additonalQuestion() {
    this.navPageNo = 8;
    this.showCandidateDetails = false;
    this.showCandidateAddressDetails = false;
    this.showCandidateEductionalDetails = false;
    this.showCandidateTrainingDetails = false;
    this.showCandidateFamilyDetails = false;
    this.showCandidateWorkExperienceDetails = false;
    this.showCandidateReferenceDetails = false;
    this.showCandidateQuestionsDetails = true;
    this.showCandidateDocumentsUpload = false;

    this.nextFlag = true;
    this.submitFlag = false;
  }
  uploadDocuments() {
    this.navPageNo = 9;
    this.showCandidateDetails = false;
    this.showCandidateAddressDetails = false;
    this.showCandidateEductionalDetails = false;
    this.showCandidateTrainingDetails = false;
    this.showCandidateFamilyDetails = false;
    this.showCandidateWorkExperienceDetails = false;
    this.showCandidateReferenceDetails = false;
    this.showCandidateQuestionsDetails = false;
    this.showCandidateDocumentsUpload = true;

    this.nextFlag = false;
    this.submitFlag = true;
  }

  onchangeDocument() {
    
    // console.log("hey");
  }

  setcandidateDetailForm(request: any) {
   
    this.selectedCandidateForm.controls.salutation.setValue(request.salutation);
    this.selectedCandidateForm.controls.name.setValue(request.name);
    this.selectedCandidateForm.controls.dateOfBirth.setValue(
      request.dateOfBirth
    );
    this.selectedCandidateForm.controls.panNumber.setValue(request.panNo);
    this.selectedCandidateForm.controls.aadharNumber.setValue(request.aadharNo);
    this.selectedCandidateForm.controls.nationality.setValue(
      request.nationality
    );
    this.selectedCandidateForm.controls.positionAppliedFor.setValue(
      request.positionAppliedFor
    );
    this.selectedCandidateForm.controls.fatherName.setValue(request.fatherName);
    this.selectedCandidateForm.controls.fatherAadhar.setValue(
      request.fatherAadhar
    );
    this.selectedCandidateForm.controls.motherName.setValue(request.motherName);
    this.selectedCandidateForm.controls.motherAadhar.setValue(
      request.motherAadhar
    );
    this.selectedCandidateForm.controls.emergencyContactName.setValue(
      request.emergencyContactName
    );
    this.selectedCandidateForm.controls.emergencyContactNumber.setValue(
      request.emergencyContactNumber
    );
    this.selectedCandidateForm.controls.emergencyContactRelation.setValue(
      request.emergencyContactRelation
    );
    this.selectedCandidateForm.controls.permanentHouseNo.setValue(
      request.permanentHouseNo
    );
    this.selectedCandidateForm.controls.permanentStreet.setValue(
      request.permanentStreet
    );
    this.selectedCandidateForm.controls.permanentState.setValue(
      request.permanentState
    );
    this.selectedCandidateForm.controls.permanentPinCode.setValue(
      request.permanentPincode
    );
    this.selectedCandidateForm.controls.permanentEmailId.setValue(
      request.permanentEmail
    );
    this.selectedCandidateForm.controls.permanentMobileNo.setValue(
      request.permanentMobile
    );
    this.selectedCandidateForm.controls.permanentFaxNo.setValue(
      request.permanentFaxno
    );
    this.selectedCandidateForm.controls.mailingHouseNo.setValue(
      request.mailingHouseNo
    );
    this.selectedCandidateForm.controls.mailingStreet.setValue(
      request.mailingStreet
    );
    this.selectedCandidateForm.controls.mailingState.setValue(
      request.mailingState
    );
    this.selectedCandidateForm.controls.mailingPinCode.setValue(
      request.mailingPincode
    );
    this.selectedCandidateForm.controls.mailingMobileNo.setValue(
      request.mailingMobile
    );
    this.selectedCandidateForm.controls.mailingFaxNo.setValue(
      request.mailingFaxno
    );
    this.selectedCandidateForm.controls.familyBackground.setValue(
      request.familyBackground
    );

    this.selectedCandidateForm.controls.read.setValue(request.languageRead);
    this.selectedCandidateForm.controls.write.setValue(request.languageWrite);
    this.selectedCandidateForm.controls.speak.setValue(request.languageSpeak);

    this.selectedCandidateForm.controls.reference1Name.setValue(request.reference1Name);
    this.selectedCandidateForm.controls.reference1Address.setValue(request.reference1Address);
    this.selectedCandidateForm.controls.reference1ContactNo.setValue(request.reference1Contact);
    this.selectedCandidateForm.controls.reference2Name.setValue(request.reference2Name);
    this.selectedCandidateForm.controls.reference2Address.setValue(request.reference2Address);
    this.selectedCandidateForm.controls.reference2ContactNo.setValue(request.reference2Contact);
    this.selectedCandidateForm.controls.referenceQuestion.setValue(request.knowAboutVacancy);



    this.selectedCandidateForm.controls.question1.setValue(request.question1);
this.selectedCandidateForm.controls.question2.setValue(request.question2);
this.selectedCandidateForm.controls.question3.setValue(request.question3);
this.selectedCandidateForm.controls.question4.setValue(request.question4);
this.selectedCandidateForm.controls.question5.setValue(request.question5);
this.selectedCandidateForm.controls.question6.setValue(request.question6);
this.selectedCandidateForm.controls.question7.setValue(request.question7);
this.selectedCandidateForm.controls.question8.setValue(request.question8);

this.selectedCandidateForm.controls.question1Answer.setValue(request.question1Answer);
this.selectedCandidateForm.controls.question2Answer.setValue(request.question2Answer);
this.selectedCandidateForm.controls.question3Answer.setValue(request.question3Answer);
this.selectedCandidateForm.controls.question4Answer.setValue(request.question4Answer);
this.selectedCandidateForm.controls.question5Answer.setValue(request.question5Answer);
this.selectedCandidateForm.controls.question6Answer.setValue(request.question6Answer);
this.selectedCandidateForm.controls.question7Answer.setValue(request.question7Answer);
this.selectedCandidateForm.controls.question8Answer.setValue(request.question8Answer);

this.educationDetails = request.candidateEducationDetailList;
this.trainginDetials = request.candidateTrainingDetailList;
this.workExperienceDetails = request.candidateWorkExperienceList;
this.candidateDocumentDataList = request.candidateDocuments;
this.setUploadDocumentsData();

  }

  setUploadDocumentsData() {

   
      for (let i = 0; i < this.candidateDocumentDataList.length; i++) {

        switch (this.candidateDocumentDataList[i].docType) {
          case "1":
            this.document1Flag = true;
            this.id1 = this.candidateDocumentDataList[i].id;
            this.photo = this.candidateDocumentDataList[i].docName;
            break;

          case "2":
            this.document2Flag = true;
            this.id2 = this.candidateDocumentDataList[i].id;
            this.aadhar = this.candidateDocumentDataList[i].docName;
            break;

          case "3":
            this.document3Flag = true;
            this.id3 = this.candidateDocumentDataList[i].id;
            this.PAN = this.candidateDocumentDataList[i].docName;
            break;

          case "4":
            this.document4Flag = true;
            this.id4 = this.candidateDocumentDataList[i].id;
            this.updatedCV = this.candidateDocumentDataList[i].docName;
            break;

          case "5":
            this.document5Flag = true;
            this.id5 = this.candidateDocumentDataList[i].id;
            this.highschool = this.candidateDocumentDataList[i].docName;
            break;

          case "6":
            this.document6Flag = true;
            this.id6 = this.candidateDocumentDataList[i].id;
            this.inter = this.candidateDocumentDataList[i].docName;
            break;

          case "7":
            this.document7Flag = true;
            this.id7 = this.candidateDocumentDataList[i].id;
            this.grad = this.candidateDocumentDataList[i].docName;
            break;

          case "8":
            this.document8Flag = true;
            this.id8 = this.candidateDocumentDataList[i].id;
            this.postGrad = this.candidateDocumentDataList[i].docName;
            break;

          case "9":
            this.document9Flag = true;
            this.id9 = this.candidateDocumentDataList[i].id;
            this.degree = this.candidateDocumentDataList[i].docName;
            break;

          case "10":
            this.document10Flag = true;
            this.id10 = this.candidateDocumentDataList[i].id;
            this.insuranceCertificate = this.candidateDocumentDataList[i].docName;
            break;

          case "11":
            this.document11Flag = true;
            this.id11 = this.candidateDocumentDataList[i].id;
            this.previousCompany = this.candidateDocumentDataList[i].docName;
            break;

          case "12":
            this.document12Flag = true;
            this.id12 = this.candidateDocumentDataList[i].id;
            this.ctcStructure = this.candidateDocumentDataList[i].docName;
            break;

          case "13":
            this.document13Flag = true;
            this.id13 = this.candidateDocumentDataList[i].id;
            this.last3Months = this.candidateDocumentDataList[i].docName;
            break;

          case "14":
            this.document14Flag = true;
            this.id14 = this.candidateDocumentDataList[i].id;
            this.offerCurrent = this.candidateDocumentDataList[i].docName;
            break;

          case "15":
            this.id15 = this.candidateDocumentDataList[i].id;
            this.document15Flag = true;
            this.others = this.candidateDocumentDataList[i].docName;
            break;

        }
      }
    
  }


  editEducationalDetail(data: any){
    let tempEducationDetails = this.educationDetails[data];
    this.selectedCandidateForm.controls.degree.setValue(tempEducationDetails.degree);
    this.selectedCandidateForm.controls.institute.reset(tempEducationDetails.institute);
    this.selectedCandidateForm.controls.educationFromDate.reset(tempEducationDetails.durationFrom);
    this.selectedCandidateForm.controls.educationFromTo.reset(tempEducationDetails.durationTo);
    this.selectedCandidateForm.controls.coreSubject.reset(tempEducationDetails.specialization);
    this.selectedCandidateForm.controls.eduationResult.reset(tempEducationDetails.result);
    this.editEducationIndex = data;
    this.editEducationDetail = true;
  }

  editTrainingDetail(data: any){
    let tempTrainingDetails = this.trainginDetials[data];
    this.selectedCandidateForm.controls.trainingCurriculum.setValue(tempTrainingDetails.trainingCurriculum);
    this.selectedCandidateForm.controls.trainingFromDate.setValue(tempTrainingDetails.trainingFromDate);
    this.selectedCandidateForm.controls.trainingFromTo.setValue(tempTrainingDetails.trainingFromTo);
    
    this.editTrainingDetails = true;
    this.editTrainingIndex = data;

  }

  editWorkExperience(data: any){
    let tempWorkDetails = this.workExperienceDetails[data];
    this.selectedCandidateForm.controls.lastCompanyName.setValue(tempWorkDetails.nameOfCompany);
    this.selectedCandidateForm.controls.lastCompanyLocation.setValue(tempWorkDetails.location);
    this.selectedCandidateForm.controls.lastCompanyFromDate.setValue(tempWorkDetails.durationFrom);
    this.selectedCandidateForm.controls.lastCompanyFromTo.setValue(tempWorkDetails.durationTo);
    this.selectedCandidateForm.controls.lastCompanyDesigantion.setValue(tempWorkDetails.designation);
    this.selectedCandidateForm.controls.lastCompanyCTC.setValue(tempWorkDetails.costToComapany);
    this.selectedCandidateForm.controls.lastCompanyReasontoChange.setValue(tempWorkDetails.reasonForChange);
    this.selectedCandidateForm.controls.lastCompanyManager.setValue(tempWorkDetails.lastReportingManger);
    this.selectedCandidateForm.controls.lastCompanyManagerNumber.setValue(tempWorkDetails.lastReportingManagerContactNo);
    this.editWorkDetail = true;
    this.editWorkDetailIndex = data;
  }

  openDocuments(type: any) {

    let docTypeId = type.toString();
    for (let i = 0; i < this.candidateDocumentDataList.length; i++) {
      if (docTypeId == this.candidateDocumentDataList[i].docType) {
        var arr = this.candidateDocumentDataList[i].docName.split('.')[1];
        this.getDocument(this.candidateDocumentDataList[i].documentumId, arr)
      }
    }
  }

  async getDocument(option, arr) {
    let type = 'application/pdf';
    if (arr == 'jpg' || arr == 'jpeg' || arr == 'png') {
      type = 'image/jpeg';
    }
    const documentDetails = await this.joineeService.getDocument(option);

    const documentData = documentDetails[0];

    //let url: any = URL.createObjectURL(documentData);
    const blob = this.b64toBlob(documentData, type)
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');

  }

  b64toBlob(b64Data, contentType, sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
